Namespace 'AccountSettings.Topics'

class AccountSettings.Topics.TopicsSwitchView extends Backbone.View
  template: JST["backbone/templates/account_settings/topics/topics_switch"]

  events:
    "click .topics-radio-button": "onRadioButtonClick"

  initialize: (options) ->
    @switchTitle = options.title
    @enabled = options.enabled
    @valueHolder = options.valueHolder
    @switchElements = options.elements
    @selectedStrategy =  if options.selected == '' then 'automatic' else options.selected
    @_updateValueHolder(@selectedStrategy)
    super

  render: =>
    @$el.html(
      @template(title: @switchTitle, enabled: @enabled, elements: @switchElements, selectedStrategy: @selectedStrategy)
    )
    @delegateEvents()
    @

  onRadioButtonClick: (event) =>
    @selectedStrategy = event.currentTarget.dataset.value
    @_updateValueHolder(@selectedStrategy)

  hide: =>
    @$el.addClass('d-none')

  show: =>
    @$el.removeClass('d-none')

  toggleSwitchDisabledState: (enabled) =>
    @enabled = enabled
    if @enabled
      @_updateValueHolder(@selectedStrategy)
    else
      @_clearValueHolder()
    @render()

  _clearValueHolder: =>
    $(@valueHolder).val('')

  _updateValueHolder: (value) =>
    $(@valueHolder).val(value)
